import React from 'react';
import { useTheme } from '../../../context/ThemeContext';

const CandlestickRangeChart = ({ high, low, open, close, formatNumber }) => {
    const { theme } = useTheme();

    const myOpen = Math.min(open, close);
    const myClose = Math.max(open, close);
    const isProfit = close > open;

    // Calculate percentages for positioning
    const range = high - low;
    const lowToOpenPercent = ((myOpen - low) / range) * 100;
    const bodyPercent = ((myClose - myOpen) / range) * 100;
    const closeToHighPercent = ((high - myClose) / range) * 100;
    const currentPricePercent = ((close - low) / range) * 100;

    return (
        <div className="mb-4">
            {/* Labels Row */}
            <div className="flex justify-between items-center mb-2">
                <span className={`text-xs font-medium text-n500`}>
                    Low
                </span>
                <span className={`text-xs font-medium text-n500`}>
                    Today's Range
                </span>
                <span className={`text-xs font-medium text-n500`}>
                    High
                </span>
            </div>

            {/* Values and Bar Row */}
            <div className="flex items-center gap-3">
                {/* Low Value */}
                <span className={`text-xs font-medium text-p300`}>
                    {formatNumber(low)}
                </span>

                {/* Range Bar */}
                <div className="flex-1 relative">
                    {/* Background Bar */}
                    <div className="h-1.5 rounded-[1px] overflow-hidden flex">
                        {/* Low to Open - Gray */}
                        <div
                            style={{ width: `${lowToOpenPercent}%` }}
                            className={theme === 'dark' ? 'bg-[#2A2A2A]' : 'bg-[#E5E5E5]'}
                        />

                        {/* Open to Close - Green or Red */}
                        <div
                            style={{ width: `${bodyPercent}%` }}
                            className={isProfit ? 'bg-p150' : 'bg-red'}
                        />

                        {/* Close to High - Gray */}
                        <div
                            style={{ width: `${closeToHighPercent}%` }}
                            className={theme === 'dark' ? 'bg-[#2A2A2A]' : 'bg-[#E5E5E5]'}
                        />
                    </div>

                    {/* Current Price Indicator */}
                    <div
                        className="absolute -bottom-5 transform -translate-x-1/2"
                        style={{ left: `${currentPricePercent}%` }}
                    >
                        {/* Triangle Pointer */}
                        <div
                            className={`w-0 h-0 mx-auto
                border-l-[7.5px] border-l-transparent
                border-r-[7.5px] border-r-transparent
                border-b-[7px] ${theme === 'dark' ? 'border-b-[#B3B3B3]' : 'border-b-[#6B6B6B]'}`}
                        />
                        {/* Price Label */}
                        <div className={`text-[10px] font-medium mt-0.5 whitespace-nowrap ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                            {formatNumber(close)}
                        </div>
                    </div>
                </div>

                {/* High Value */}
                <span className={`text-xs font-medium text-p300`}>
                    {formatNumber(high)}
                </span>
            </div>

            {/* Spacer for the indicator label */}
            <div className="h-5" />
        </div>
    );
};

export default CandlestickRangeChart;